import { ApiRecommendationProduct } from '../../../../services/eaptekaApi';
import { RecommendationProductWithAnalytics } from '../../../recommendationProducts/types';
import { serializeUnitQuantity } from '../serializeUnitQuantity';
import { serializePrice } from '../serializePrice';

export const serializeRecommendationProduct = (
  raw: ApiRecommendationProduct
): RecommendationProductWithAnalytics => {
  return {
    id: raw.id,
    sku: raw.sku,
    name: raw.name,
    unitQuantity: serializeUnitQuantity(raw.unitQuantity),
    isPreorder: raw.preorder,
    picture: raw.picture,
    price: serializePrice(raw.price),
    oldPrice: raw.oldPrice
      ? serializePrice(raw.oldPrice)
      : null,
    isPku: raw.isPku,
    recipeOnly: raw.recipeOnly,
    hasAlcohol: raw.hasAlcohol,
    isVmt: raw.isVmt,
    isStm: raw.isStm
  } as RecommendationProductWithAnalytics;
};
